import script from "./ActionsBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionsBar.vue?vue&type=script&setup=true&lang=js"

import "./ActionsBar.vue?vue&type=style&index=0&id=2225f239&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2225f239"]])

export default __exports__